/** @file Deep copy of JSON-shaped document data (objects, arrays, strings, numbers, booleans, null). */

/** A structurally equal copy that shares nothing with `value` (immer drafts are read through their proxies). */
export function copyJson<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}
